export default __webpack_public_path__ + "static/media/Demisto.206f1f5f.png";